'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
require('./settings-9ee2f03f.js');
var badge = require('./badge.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  ", "\n  ", "\n  ", "\n\n  @media (max-width: 991px) {\n    ", "\n    ", "\n    ", "\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  ", "\n  ", "\n  ", "\n\n  @media (max-width: 991px) {\n    ", "\n    ", "\n    ", "\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  ", "\n  ", "\n\n  @media (max-width: 991px) {\n    ", "\n    ", "\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  ", "\n  ", "\n\n  @media (max-width: 991px) {\n    ", "\n    ", "\n  }\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n  font-size: 14px;\n  font-family: Source Sans Pro, sans-serif;\n  font-weight: 400;\n  line-height: 20px;\n  color: ", ";\n  margin-bottom: 5px;\n"], ["\n  font-size: 14px;\n  font-family: Source Sans Pro, sans-serif;\n  font-weight: 400;\n  line-height: 20px;\n  color: ", ";\n  margin-bottom: 5px;\n"]),
    _templateObject5 = _babelHelpers.taggedTemplateLiteral(["\n  background: #3b99fc;\n  height: 3px;\n  width: 100%;\n"], ["\n  background: #3b99fc;\n  height: 3px;\n  width: 100%;\n"]),
    _templateObject6 = _babelHelpers.taggedTemplateLiteral(["\n  border-top: 1px solid #e5e5e5;\n  width: 100%;\n  ", "\n"], ["\n  border-top: 1px solid #e5e5e5;\n  width: 100%;\n  ", "\n"]),
    _templateObject7 = _babelHelpers.taggedTemplateLiteral(["\n      position: absolute;\n      left: 0;\n    "], ["\n      position: absolute;\n      left: 0;\n    "]),
    _templateObject8 = _babelHelpers.taggedTemplateLiteral(["\n  width: 100%;\n  ", "\n"], ["\n  width: 100%;\n  ", "\n"]);

var Container = styled__default.div(_templateObject, function (props) {
  return props.margin && "margin: " + props.margin + ";";
}, function (props) {
  return props.padding && "padding: " + props.padding + ";";
}, function (props) {
  return props.background && "background: " + props.background + ";";
}, function (props) {
  return props.mMargin && "margin: " + props.mMargin + ";";
}, function (props) {
  return props.mPadding && "padding: " + props.mPadding + ";";
}, function (props) {
  return props.mBackground && "background: " + props.mBackground + ";";
});

var Tabs = styled__default.div(_templateObject2, function (props) {
  return props.maxWidth && "max-width: " + props.maxWidth + ";";
}, function (props) {
  return props.colGap && "column-gap: " + props.colGap + ";";
}, function (props) {
  return props.mMaxWidth && "max-width: " + props.mMaxWidth + ";";
}, function (props) {
  return props.mColGap && "column-gap: " + props.mColGap + ";";
});

var Header = styled__default.div(_templateObject3);

var HeaderTitle = styled__default.div(_templateObject4, function (props) {
  return props.active ? "#3B99FC" : "#333";
});

var ActiveSign = styled__default.div(_templateObject5);

var Hr = styled__default.div(_templateObject6, function (props) {
  return props.absoluteHr && styled.css(_templateObject7);
});

var Content = styled__default.div(_templateObject8, function (props) {
  return props.absoluteHr && "margin-top: 1px;";
});

var TabsHeader = function TabsHeader(_ref) {
  var active = _ref.active,
      label = _ref.label,
      onClick = _ref.onClick,
      badge$1 = _ref.badge;
  return React__default.createElement(
    Header,
    { onClick: onClick },
    React__default.createElement(
      HeaderTitle,
      { active: active },
      label,
      badge$1 && React__default.createElement(
        badge.default,
        null,
        badge$1
      )
    ),
    active && React__default.createElement(ActiveSign, null)
  );
};

var TabsBar = function TabsBar(_ref2) {
  var tabs = _ref2.tabs,
      activeKey = _ref2.activeKey,
      maxWidth = _ref2.maxWidth,
      mMaxWidth = _ref2.mMaxWidth,
      tabSpace = _ref2.tabSpace,
      mTabSpace = _ref2.mTabSpace,
      headerMargin = _ref2.headerMargin,
      mHeaderMargin = _ref2.mHeaderMargin,
      headerPadding = _ref2.headerPadding,
      mHeaderPadding = _ref2.mHeaderPadding,
      headerBg = _ref2.headerBg,
      mHeaderBg = _ref2.mHeaderBg,
      contentMargin = _ref2.contentMargin,
      mContentMargin = _ref2.mContentMargin,
      contentPadding = _ref2.contentPadding,
      mContentPadding = _ref2.mContentPadding,
      contentBg = _ref2.contentBg,
      mContentBg = _ref2.mContentBg,
      absoluteHr = _ref2.absoluteHr;

  var keys = Object.keys(tabs);

  var _React$useState = React__default.useState(activeKey || keys[0]),
      _React$useState2 = _babelHelpers.slicedToArray(_React$useState, 2),
      currentKey = _React$useState2[0],
      setCurrentKey = _React$useState2[1];

  React__default.useEffect(function () {
    if (activeKey) setCurrentKey(activeKey);
  }, [activeKey]);

  var active = tabs[currentKey];

  var onClickTab = function onClickTab(key, onClick) {
    return function () {
      setCurrentKey(key);
      if (onClick) onClick(key);
    };
  };

  return React__default.createElement(
    "div",
    { className: "tabs-bar-root" },
    React__default.createElement(
      Container,
      {
        margin: headerMargin,
        mMargin: mHeaderMargin,
        padding: headerPadding,
        mPadding: mHeaderPadding,
        background: headerBg,
        mBackground: mHeaderBg },
      React__default.createElement(
        Tabs,
        {
          maxWidth: maxWidth,
          mMaxWidth: mMaxWidth,
          colGap: tabSpace,
          mColGap: mTabSpace },
        keys.map(function (key) {
          return React__default.createElement(TabsHeader, {
            key: key,
            active: key === currentKey,
            label: tabs[key].label,
            onClick: onClickTab(key, tabs[key].onClick),
            badge: tabs[key].badge
          });
        })
      )
    ),
    React__default.createElement(Hr, { absolute: absoluteHr }),
    React__default.createElement(
      Container,
      {
        margin: contentMargin,
        mMargin: mContentMargin,
        padding: contentPadding,
        mPadding: mContentPadding,
        background: contentBg,
        mBackground: mContentBg },
      React__default.createElement(
        Content,
        { absoluteHr: absoluteHr },
        active && active.content
      )
    )
  );
};

TabsBar.propTypes = {
  /** Tabs contain the content of each tab and title.
   * Tabs format will be an object with title and content keys. For example: {transactions: {label: 'Transactions',content: <div />, onClick: () => {}} */
  tabs: PropTypes$1.objectOf({
    label: PropTypes$1.string.isRequired,
    content: PropTypes$1.element.isRequired,
    onClick: PropTypes$1.func,
    badge: PropTypes$1.string
  }).isRequired,
  /** Current active key (Must same as tabs key). Default will be first object key  */
  activeKey: PropTypes$1.string,
  /** Make hr absolute */
  absoluteHr: PropTypes$1.bool,
  /** Max width for all */
  maxWidth: PropTypes$1.string,
  /** Max width for all on mobile */
  mMaxWidth: PropTypes$1.string,
  /** Space between tabs */
  tabSpace: PropTypes$1.string,
  /** Space between tabs on mobile */
  mTabSpace: PropTypes$1.string,
  /** Margin for header */
  headerMargin: PropTypes$1.string,
  /** Margin for header on mobile */
  mHeaderMargin: PropTypes$1.string,
  /** Padding for header */
  headerPadding: PropTypes$1.string,
  /** Padding for header on mobile */
  mHeaderPadding: PropTypes$1.string,
  /** Background for header */
  headerBg: PropTypes$1.string,
  /** Background for header on mobile */
  mHeaderBg: PropTypes$1.string,
  /** Margin for content */
  contentMargin: PropTypes$1.string,
  /** Margin for content on mobile */
  mContentMargin: PropTypes$1.string,
  /** Padding for content */
  contentPadding: PropTypes$1.string,
  /** Padding for content on mobile */
  mContentPadding: PropTypes$1.string,
  /** Background for content */
  contentBg: PropTypes$1.string,
  /** Background for content on mobile */
  mContentBg: PropTypes$1.string
};
TabsHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TabsHeader"
};
TabsBar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TabsBar",
  "props": {
    "tabs": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "custom",
          "raw": "{\n  label: PropTypes.string.isRequired,\n  content: PropTypes.element.isRequired,\n  onClick: PropTypes.func,\n  badge: PropTypes.string\n}"
        }
      },
      "required": true,
      "description": "Tabs contain the content of each tab and title.\nTabs format will be an object with title and content keys. For example: {transactions: {label: 'Transactions',content: <div />, onClick: () => {}}"
    },
    "activeKey": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Current active key (Must same as tabs key). Default will be first object key"
    },
    "absoluteHr": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Make hr absolute"
    },
    "maxWidth": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Max width for all"
    },
    "mMaxWidth": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Max width for all on mobile"
    },
    "tabSpace": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Space between tabs"
    },
    "mTabSpace": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Space between tabs on mobile"
    },
    "headerMargin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Margin for header"
    },
    "mHeaderMargin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Margin for header on mobile"
    },
    "headerPadding": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Padding for header"
    },
    "mHeaderPadding": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Padding for header on mobile"
    },
    "headerBg": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Background for header"
    },
    "mHeaderBg": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Background for header on mobile"
    },
    "contentMargin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Margin for content"
    },
    "mContentMargin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Margin for content on mobile"
    },
    "contentPadding": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Padding for content"
    },
    "mContentPadding": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Padding for content on mobile"
    },
    "contentBg": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Background for content"
    },
    "mContentBg": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Background for content on mobile"
    }
  }
};

exports.TabsBar = TabsBar;
exports.TabsHeader = TabsHeader;
exports.default = TabsBar;
//# sourceMappingURL=tabs-bar.js.map
